import React, {useState} from 'react'
import {Button} from 'antd';
import BookNumberModal from "./BookNumberModal";

function BookNumber(props) {
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <Button className="ml-3" onClick={_toggleModal} type="primary">Book số</Button>
        {showModal && <BookNumberModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default BookNumber
